var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"member-event-editor-modal",attrs:{"size":"xl","hide-footer":""}},[_c('MemberEventEditor',{attrs:{"item":_vm.item,"events":_vm.events,"event":_vm.event},on:{"updated":_vm.updated_member_event,"created":_vm.created_member_event}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }